// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import history from 'src/history';
import CommonLayout from './../../components/CommonLayout';
import DeviceInformation from './../../components/DeviceInformation';
import { OrderSummary, OrderButton } from './../../components/Order';
import { statusSelector } from './../../components/ServiceRequestAndDeviceLookup/selector';

import { LoadingState } from './../../store/actionStatus';
import { CHECKOUT_ORDER,reActivateOrderStatusSelector, PURCHASE_ON_DEMAND_ORDER } from './../../store/orderCreation';
import { secondSRCreationSelector, selectConfirmation } from './../../store/orderCreation/selectors';

import Styles from './billingAndReview.module.scss';

export default function BillingAndReview(props: any) {
    const { t } = useTranslation();

    const {
        state = {},
    } = props.location;

    const [deviceProps] = React.useState(state.deviceProps);

    let orderStatus = useSelector(state => statusSelector(state)(CHECKOUT_ORDER));
    const reActivateOrder = useSelector(state => reActivateOrderStatusSelector(state));
    const secondSRCreation = useSelector(state => secondSRCreationSelector(state));
    let confirmation: any;
    
    // for onsite order we are using the same methods of on demand
    if(reActivateOrder || secondSRCreation){
        orderStatus = useSelector(state => statusSelector(state)(PURCHASE_ON_DEMAND_ORDER));
    }
    if (orderStatus.status === LoadingState.rejected) {
        return <div>Error has occurred while placing order</div>; //TODO: should be handle centrally
    }

    confirmation = useSelector(state => selectConfirmation(state) || {});
    if (!orderStatus || Object.keys(orderStatus).length === 0) {
        // This is possibly a direct mount, redirect to homepage
        history.replace('/');
        return null;
    }

    return (
        <CommonLayout
            loading={orderStatus.status === LoadingState.started}
            loadingMessage={t('placing_order')}
            pageTitle={[t('billing_and_review')]}
        >
            <div className={Styles.container} >
                <div className={Styles.deviceInfo}>
                    <DeviceInformation {...deviceProps} />
                </div>
                <OrderSummary confirmation={confirmation} />
                <OrderButton className={Styles.marginBottom30} />
            </div >
        </CommonLayout >
    );
}